import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";

/**
 * Example usage of the shadcn/Radix-based {@link Tabs} primitive — the pure,
 * state-based tab control (active tab held in local state, no URL change).
 * For tab bars that drive page navigation (deep-linkable customer/consultant
 * sub-pages) use the route-aware `Core/RouteTabs` wrapper instead.
 */
const TabsExample: React.FC = () => {
	return (
		<div className="max-w-xl space-y-8 p-6">
			<div>
				<h2 className="mb-2 text-xl font-bold">Tabs (primitive)</h2>
				<p className="text-sm text-gray-600">
					A Tailwind-styled wrapper over <code>@radix-ui/react-tabs</code>. State-based — the
					default segmented look. Customise any part via the <code>className</code> props.
				</p>
			</div>

			{/* Default segmented look */}
			<div className="space-y-2">
				<h3 className="font-medium">Default (uncontrolled)</h3>
				<Tabs defaultValue="account" className="w-full">
					<TabsList>
						<TabsTrigger value="account">Account</TabsTrigger>
						<TabsTrigger value="password">Password</TabsTrigger>
						<TabsTrigger value="team" disabled>
							Team
						</TabsTrigger>
					</TabsList>
					<TabsContent value="account" className="rounded-md border border-gray-200 p-4 text-sm">
						Manage your account details here.
					</TabsContent>
					<TabsContent value="password" className="rounded-md border border-gray-200 p-4 text-sm">
						Change your password here. The “Team” trigger is disabled.
					</TabsContent>
				</Tabs>
			</div>

			{/* Full-width track */}
			<div className="space-y-2">
				<h3 className="font-medium">Full width</h3>
				<Tabs defaultValue="overview" className="w-full">
					<TabsList className="grid w-full grid-cols-3">
						<TabsTrigger value="overview">Overview</TabsTrigger>
						<TabsTrigger value="activity">Activity</TabsTrigger>
						<TabsTrigger value="settings">Settings</TabsTrigger>
					</TabsList>
					<TabsContent value="overview" className="text-sm text-gray-600">
						Overview panel
					</TabsContent>
					<TabsContent value="activity" className="text-sm text-gray-600">
						Activity panel
					</TabsContent>
					<TabsContent value="settings" className="text-sm text-gray-600">
						Settings panel
					</TabsContent>
				</Tabs>
			</div>
		</div>
	);
};

export default TabsExample;
